/************************************************************************************

* [UTILITY FUNCTIONS]

*************************************************************************************/
function l_debounce(fn, wait) {
	let t

	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

function l_fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
	}
}

function l_setupGlobalVariables() {
	// Set scrollbar width
	const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
	document.documentElement.style.setProperty('--l-body-scrollbar-width', `${scrollBarWidth}px`)
}

function l_setupVariablesBeforeOpenModal() {
	// Elements
	const announcementBarSection = document.getElementById('announcementBar')
	const headerSection = document.getElementById('header')

	// Set CSS variables
	document.documentElement.style.setProperty('--l-viewport-height', `${visualViewport?.height ?? window.innerHeight}px`)
	document.documentElement.style.setProperty('--l-header-height', `${headerSection?.offsetHeight || 0}px`)
	document.documentElement.style.setProperty(
		'--l-announcement-bar-height',
		`${announcementBarSection?.offsetHeight || 0}px`
	)

	return {
		headerHeight: headerSection?.offsetHeight || 0,
		announcementBarHeight: announcementBarSection?.offsetHeight || 0,
		headerTotalHeight: (headerSection?.offsetHeight || 0) + (announcementBarSection?.offsetHeight || 0),
		viewportHeight: visualViewport?.height ?? window.innerHeight,
	}
}

/************************************************************************************

* [ADD TO CART MODULE]

*************************************************************************************/

class LTACartServices {
	constructor(cartDrawer = null) {
		this.cartDrawer = cartDrawer
	}

	getBaseConfig() {
		return {
			method: 'POST',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
			},
		}
	}

	createConfigFromForm(formEl) {
		const config = this.getBaseConfig()
		config.body = new FormData(formEl)

		return config
	}

	createConfigFromItems(items = []) {
		const config = this.getBaseConfig()
		const formData = new FormData()

		items.forEach((item, index) => {
			formData.append(`items[${index}][id]`, item.id)
			formData.append(`items[${index}][quantity]`, item.quantity)
		})

		config.body = formData

		return config
	}

	async addToCart(config, id = 'default') {
		// Note: Don't use finally / catch here

		return fetch(`${window.routes.cart_add_url}.js`, config)
			.then((res) => res.json())
			.then((data) => {
				console.log(data)

				if (data.status) {
					document.dispatchEvent(new CustomEvent('l:cart:error', { detail: { id, description: data.description } }))

					return data
				}

				document.dispatchEvent(new CustomEvent('l:product:added', { bubbles: true, detail: { id, response: data } }))

				return data
			})
	}

	async changeCartLineItem(formData) {
		return fetch(`${window.routes.cart_change_url}.js`, { ...l_fetchConfig(), body: JSON.stringify(formData) })
			.then((res) => res.json())
			.then((data) => {
				return data
			})
	}
}

const ltaCartService = new LTACartServices()

/************************************************************************************

* [GENERAL COMPONENTS]

*************************************************************************************/

/*****************************************
 * [COMPONENT]: ATC BUTTON
 ******************************************/

if (!customElements.get('l-atc-button')) {
	customElements.define(
		'l-atc-button',
		class LTACTAButton extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				// Elements
				this.buttonEl = this.querySelector('button')

				// Events
				this.buttonEl.addEventListener('click', this.handleAtcBtnClick.bind(this))
			}

			handleAtcBtnClick() {
				this.buttonEl.classList.add('is-loading', 'l-button-loading')

				const formData = ltaCartService.createConfigFromItems([
					{ id: this.dataset.variantId, quantity: parseInt(this.dataset.quantity) },
				])

				ltaCartService
					.addToCart(formData, 'l-atc-button')
					.then((res) => {})
					.finally(() => {
						this.buttonEl.classList.remove('is-loading', 'l-button-loading')
					})
			}
		}
	)
}

/************************************************************************************
 *
 * [PDP SECTIONS]:
 *
 *************************************************************************************/

/******************************
 * SECTION: PRODUCT RECOMMENDATIONS
 *******************************/

if (!customElements.get('l-product-recommendations')) {
	customElements.define(
		'l-product-recommendations',
		class LTAProductRecommendations extends HTMLElement {
			observer = undefined

			constructor() {
				super()
			}

			connectedCallback() {
				this.initializeRecommendations()
			}

			initializeRecommendations() {
				this.observer?.unobserve(this)
				this.observer = new IntersectionObserver(
					(entries, observer) => {
						if (!entries[0].isIntersecting) return
						observer.unobserve(this)
						this.loadRecommendations()
					},
					{ rootMargin: '0px 0px 800px 0px' }
				)
				this.observer.observe(this)
			}

			loadRecommendations() {
				console.log(this.dataset.url)

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div')
						html.innerHTML = text
						const recommendations = html.querySelector('l-product-recommendations')

						console.log(recommendations)

						if (recommendations?.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML
						} else {
							this.parentElement.classList.add('l-hidden')
						}
					})
					.catch((e) => {
						console.error(e)
					})
			}
		}
	)
}

/************************************************************************************

* RUN GLOBAL FUNCTIONALITIES / RUN BASE FUNCTIONALITIES

*************************************************************************************/

window.addEventListener('DOMContentLoaded', () => {
	// Initialize
	l_setupGlobalVariables()
	l_setupVariablesBeforeOpenModal()
})

window.addEventListener(
	'scroll',
	l_debounce(() => {
		// Update variables
		l_setupVariablesBeforeOpenModal()
	}, 20)
)

window.addEventListener(
	'resize',
	l_debounce(() => {
		// Update variables
		l_setupVariablesBeforeOpenModal()
	}, 20)
)

if (window.visualViewport) {
	window.visualViewport.addEventListener(
		'resize',
		l_debounce(() => {
			l_setupVariablesBeforeOpenModal()
		}, 30)
	)
}

/**********************************
 * HANDLE UPDATE CART COUNT
 **********************************/
function fetchAndUpdateCartCount() {
	fetch(`${window.routes.cart_url}.js`)
		.then((res) => res.json())
		.then((cartData) => {
			const cartCountEls = document.querySelectorAll('[data-cart-count]')

			cartCountEls.forEach((cartCountEl) => {
				cartCountEl.innerHTML = cartData.item_count
			})
		})
}
document.addEventListener('l:product:added', (event) => {
	fetchAndUpdateCartCount()
})

